import {tokenRegister} from "./tokenRegister";

class dataRegister {

    static api = {
        primehit: "https://api.devprimehit.com/v1",
        primehit2: "https://api.devprimehit.com/v2"
        //primehit : "https://api.primehit.com/v1",
        //primehit2 : "https://api.primehit.com/v2",
    };

    static stripe_key = "pk_test_B9jdmNTexEN4un2OxcRiMKMk";

    static setApiDomain(value){
        if(value === "live"){
            dataRegister.api.primehit = "https://api.primehit.com/v1";
            dataRegister.api.primehit2 = "https://api.primehit.com/v2";
            dataRegister.stripe_key = "pk_live_qcjyGkdLzPAqAubGOQ9wJKzN";
        }else if(value === "local"){
            dataRegister.api.primehit = "http://adbop/v1";
            dataRegister.api.primehit2 = "http://adbop/v2";
        }else{
            dataRegister.api.primehit = "https://api.devprimehit.com/v1";
            dataRegister.api.primehit2 = "https://api.devprimehit.com/v2";
            //dataRegister.api.primehit = "https://api.primehit.com/v1";
            //dataRegister.api.primehit2 = "https://api.primehit.com/v2";
        }
        console.log(dataRegister.api.primehit);
        console.log(dataRegister.api.primehit2);
    }

    static salesChannel = "adbop";

    static domain = "devadbop.com";

    static scraper = "https://propertybooster.herokuapp.com";
    //static scraper = "http://localhost:5000";

    static setDomain(value){
        if(value){
            dataRegister.domain = value;
        }
    }

    static getDomain(){
        return dataRegister.domain;
    }

    static documentLocation() {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch(document.location, data)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static analyzeImage(image) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                body: image
            };
            fetch(dataRegister.scraper + "/api/analyze", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static checkCoupon(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit + '/' + market + "/account/coupon/" + id, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getIp() {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch("https://ipapi.co/json/", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getIpLocation(ip) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch("https://api.ipstack.com/"+ip+"?access_key=8044eacb4d849a5c4999c87ab44b3efc", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getIpWebsite(website) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch("https://pro.ip-api.com/json/" + website+ "?key=IXve9OMOsXKH9Ir", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getImages(data) {
        let object = {
            industry: data.industry,
            market: data.market,
            page: data.page,
            amount: data.amount ? data.amount : 3
        };
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit2 + '/' + object.market + "/static/images/" + object.industry + "/" + object.page + "/" + object.amount, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getQuotes(industry, market, lang) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
            };
            fetch(dataRegister.api.primehit + "/" + market + "/" + lang + "/static/slogans/" + industry, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getIndustries(market, lang, query, limit) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            let string = dataRegister.api.primehit2 + "/" + market + "/" + lang + "/static/"+ "adbop" +"/industries";
            if(query){
                string = string + "?search=" + query + (limit?("&limit="+limit):"");
            }
            if(limit && !query){
                string = string + (limit?("?limit="+limit):"");
            }
            if(tokenRegister.get()){
                data.headers = {'Authorization': tokenRegister.get()}
            }
            fetch(string, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getRegions(market, regions) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
            };
            let url_string = "";
            if (regions) {
                url_string = dataRegister.api.primehit + "/" + market + "/static/region/" + regions;
            } else {
                url_string = dataRegister.api.primehit + "/" + market + "/static/region"
            }
            fetch(url_string, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getBudget(market, lang, industry, regions, related, duration, og) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch(dataRegister.api.primehit2 + "/" + market + "/" + lang + "/static/" + dataRegister.salesChannel +"/budget?campaign_duration="+duration+"&industry_id=" + industry + "&region_id=" + (regions ? encodeURIComponent(regions) : 0) + "&related=" + (related ? encodeURIComponent(related) : 0) + "&og=" + og, data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getMarkets(market, lang) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
            };
            fetch(dataRegister.api.primehit + "/" + market + "/" + lang + "/static/markets", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getRelatedIndustries(market, lang, industry) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
            };
            fetch(dataRegister.api.primehit2 + "/" + market + "/" + lang + "/static/adbop/industries/" + industry + "/related", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getLanguages() {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit + '/languages', data)
                .then((response) => response.json())
                .then((responseJson) => {
                    if (responseJson.success) {
                        resolve(responseJson.data);
                    } else {
                        reject(responseJson);
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static archiveCampaign(market, lang, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': tokenRegister.get()
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang + "/campaign/" + id + '/archive', data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static signIn(market, user) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Referer': 'http://autopilot.primehit/enduser/general'
                },
                body: JSON.stringify(user)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + dataRegister.salesChannel + "/login", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static signUp(market, user) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Referer': 'http://autopilot.primehit/enduser/general'
                },
                body: JSON.stringify(user)
            };
            fetch(dataRegister.api.primehit2 + '/' + market +"/"+ dataRegister.salesChannel + "/signup", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static createCampaign(market, campaign) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get()
                },
                body: campaign
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/createusercampaign", data)
                .then((response) => response.json())
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getCampaigns(market, lang, status) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang + "/campaigns/" + status, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getCampaign(market, lang, hash) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang + "/campaign/" + hash, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static terminateCampaign(market, hash) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/terminatecampaign/" + hash, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getInvoices(market, lang, page, per_page) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang + "/invoices?page=" + page + "&per_page=" + per_page, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getInvoice(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/invoice/" + id, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static sendForgotpassword(market, email) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(email)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/"+ dataRegister.salesChannel + "/resetpassword", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static sendResetpassword(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/"+ dataRegister.salesChannel + "/changepasswordwithpin", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static sendResetpasswordWithToken(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/"+ dataRegister.salesChannel + "/changepassword", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getPublicCampaigns(market, lang) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + lang +"/"+ dataRegister.salesChannel +"/randomcampaigns/3", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getTrendingIndustries(market, lang) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/"+ lang +"/"+ dataRegister.salesChannel+ "/mostpopularindustries/5", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getAccount(market) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit + '/' + market + "/account", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static postAccount(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit + '/' + market + "/account", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static referAccount(market, account) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(account)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + dataRegister.salesChannel + "/refer", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static referredAccounts(market) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                }
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/referrals", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static sendIndustryRequest(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/" + dataRegister.salesChannel + "/contact", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static setRenew(market, hash, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(info)
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/updatecampaign/" + hash, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static getInsights(market) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Authorization': tokenRegister.get(),
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/insights", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static getSalesChannelData(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/static/salesforce/" + id, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static postProfileImage(market, info) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Authorization': tokenRegister.get(),
                },
                body: info
            };
            fetch(dataRegister.api.primehit2 + '/' + market + "/profileimage", data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getFacebookTargeting(market, type, phrase) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch("https://api.primehit.com/v2" + '/' + market + "/facebooktargetingsearch?type=" + type + "&phrase=" + phrase, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    }

    static markets(market, lang) {
        return dataRegister.getMarkets(market, lang);
    }

    static images(data) {
        return dataRegister.getImages(data);
    }

    static quotes(industry, market, lang) {
        return dataRegister.getQuotes(industry, market, lang);
    }

    static industries(market, lang, query, limit) {
        return dataRegister.getIndustries(market, lang, query, limit);
    }

    static regions(market, regions) {
        return dataRegister.getRegions(market, regions);
    }

    static budget(market, lang, industry, regions, related, duration, og) {
        return dataRegister.getBudget(market, lang, industry, regions, related, duration, og);
    }

    static related(market, lang, industry) {
        return dataRegister.getRelatedIndustries(market, lang, industry);
    }

    static languages() {
        return dataRegister.getLanguages();
    }

    static login(market, data) {
        return dataRegister.signIn(market, data);
    }

    static register(data) {
        return dataRegister.signUp(data);
    }

    static campaign(market, campaign) {
        return dataRegister.createCampaign(market, campaign);
    }

    static campaigns(market, lang, status) {
        return dataRegister.getCampaigns(market, lang, status);
    }

    static singleCampaign(market, lang, id) {
        return dataRegister.getCampaign(market, lang, id);
    }

    static invoices(market) {
        return dataRegister.getInvoices(market);
    }

    static invoice(market, id) {
        return dataRegister.getInvoice(market, id);
    }

    static forgotPassword(market, data) {
        return dataRegister.sendForgotpassword(market, data);
    }

    static resetPassword(market, data) {
        return dataRegister.sendResetpassword(market, data);
    }

    static resetPasswordToken(market, data) {
        return dataRegister.sendResetpasswordWithToken(market, data);
    }

    static publicCampaigns(market, lang) {
        return dataRegister.getPublicCampaigns(market, lang);
    }

    static trendingIndustries(market, lang) {
        return dataRegister.getTrendingIndustries(market, lang);
    }

    static account(market) {
        return dataRegister.getAccount(market);
    }

    static editAccount(market, info) {
        return dataRegister.postAccount(market, info);
    }

    static refer(market, account) {
        return dataRegister.referAccount(market, account);
    }

    static referred(market){
        return dataRegister.referredAccounts(market);
    }

    static industryRequest(market, info){
        return dataRegister.sendIndustryRequest(market, info);
    }

    static renew(market, hash, info){
        return dataRegister.setRenew(market, hash, info);
    }

    static insights(market){
        return dataRegister.getInsights(market);
    }

    static saleschannel(market, id){
        return dataRegister.getSalesChannelData(market, id);
    }

    static facebookTargeting(market, type, phrase){
        return dataRegister.getFacebookTargeting(market, type, phrase);
    }

}

export {dataRegister}


// WEBPACK FOOTER //
// ./src/services/dataRegister.js